import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import React, {forwardRef, useEffect} from "react";
import {useAppSelector} from "redux/hooks";
import {TRANG_THAI_MUA_SAM} from "types/enums/shopping";
const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 12};
const {xs, sm, md, xl, lg} = css;
const ModalSend = forwardRef((props: any, ref) => {
  const {submit, closeModal, isLoading} = props;
  const [form] = Form.useForm();
  const {detailProposeShopping} = useAppSelector(
    state => state.proposeShopping
  );
  const submitSend = async () => {
    try {
      const values = await form.validateFields();
      submit(
        {
          trangThai: TRANG_THAI_MUA_SAM.CHO_DUYET,
          nguoiDuyet: values?.nguoiDuyet,
        },
        "Đã gửi đề nghị đến trưởng bộ phận"
      );
      closeModal();
    } catch (error) {}
  };
  return (
    <Spin spinning={isLoading}>
      <Typography.Text strong>Chọn người phê duyệt</Typography.Text>
      <Form form={form}>
        <Row justify={"space-between"} gutter={[8, 8]}>
          <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
            <Form.Item>
              <Input disabled value={"Trưởng bộ phận"}></Input>
            </Form.Item>
          </Col>

          <Col xs={xs} sm={sm} md={md} xl={xl} lg={lg}>
            <Form.Item
              name="nguoiDuyet"
              rules={[{required: true, message: "Bắt buộc nhập"}]}
            >
              <Input></Input>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row justify={"end"} style={{marginTop: 8}}>
        <Space>
          <Button onClick={closeModal}>Hủy</Button>{" "}
          <Button type="primary" onClick={submitSend}>
            Gửi
          </Button>
        </Space>
      </Row>
    </Spin>
  );
});

export default ModalSend;
